<template>
  <div class="event-list">
    <div class="date-title">
      <span>
        {{infos.date | defineFormatDate}}
        <template v-if="infos.courseQuantity">
          （{{ infos.courseQuantity }}节课）
        </template>
      </span>
    </div>
    <template v-if="infos.courseArrangeRecordVos">
      
      <CourseCard  v-for="item of infos.courseArrangeRecordVos" :key="item.id" :item="item" />


      <div v-if="app.permission.op('add_course_arrange')" style="text-align: center;">未提前排课？直接
        <span style="color: var(--tlc);" @click="$router.push('/classPaiKeAdd?isQuick=1')">快速排课点名</span>
      </div>
    </template>

    <!-- <div class="list" v-if="infos.isToDay && !infos.list.length">
      没有课程安排哦～
    </div> -->
  </div>
</template>

<script>
import CourseCard from '@teacher/components/course-card.vue';

export default {
  name: "EventList",
  components: {
    CourseCard
  },
  props: {
    infos: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data: () => ({
    day: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    now:Date.now(),
  }),
  filters: {

    defineFormatDate(date){
      let day = app.tool.date.formatDatetime(date,'yyyy-MM-dd'),
          today = app.tool.date.formatDatetime(Date.now(),'yyyy-MM-dd');
      if (day == today){
        return '今日/' + app.tool.date.getWeek(date)
      } else {
        return app.tool.date.formatDatetime(date,"MM月dd日") + '/' + app.tool.date.getWeek(date)
      }
    },
  },
  methods: {
    gotoCourseArrange(id) {
      this.$router.push(`/courseArrange/${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.event-list {
  padding:0 calc(var(--gap) * 16);
  .date-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: calc(var(--gap) * 12) 0;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
  }

}
</style>
